import React from 'react';
import PropTypes from 'prop-types';
import extend from 'object-assign';
import translator from '../translations/drupalTranslator';

const Translate = (props) => {
  const options = props.options || {};
  const args = props.args || {};
  const component = props.component || 'span';

  const translation = translator.translate(props.content,
    args,
    options,
    component);


  // Remove props and pass the rest to the component.
  // Work-around to remove the content property.
  const subProps = extend({},
    props) || {};
  delete subProps.options;
  delete subProps.args;
  delete subProps.content;
  delete subProps.component;

  if (React.isValidElement(translation)) {
    return translation;
  }
  // We are passing properties we do not want to the sub component.
  return React.createElement(component,
    subProps,
    translation);
};

Translate.PropTypes = {
  content:PropTypes.string.isRequired,
  options:PropTypes.object,
  args:PropTypes.object,
  component:PropTypes.string,
};

export default Translate;
